import { render, staticRenderFns } from "./HomeFollowUp.vue?vue&type=template&id=1b6f2149&scoped=true"
import script from "./HomeFollowUp.vue?vue&type=script&lang=js"
export * from "./HomeFollowUp.vue?vue&type=script&lang=js"
import style0 from "./HomeFollowUp.vue?vue&type=style&index=0&id=1b6f2149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f2149",
  null
  
)

export default component.exports